import { render, staticRenderFns } from "./z_ueditor.vue?vue&type=template&id=3af8c57e&scoped=true"
import script from "./z_ueditor.vue?vue&type=script&lang=js"
export * from "./z_ueditor.vue?vue&type=script&lang=js"
import style0 from "./z_ueditor.vue?vue&type=style&index=0&id=3af8c57e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af8c57e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3af8c57e')) {
      api.createRecord('3af8c57e', component.options)
    } else {
      api.reload('3af8c57e', component.options)
    }
    module.hot.accept("./z_ueditor.vue?vue&type=template&id=3af8c57e&scoped=true", function () {
      api.rerender('3af8c57e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobilePage/z_ueditor.vue"
export default component.exports